/**
 * LegalPage — Renders a markdown file from /legal/ as a styled page.
 * Used for Terms of Service and Privacy Policy.
 *
 * Usage:
 *   <LegalPage file="TERMS_OF_SERVICE.md" />
 *   <LegalPage file="PRIVACY_POLICY.md" />
 */

import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import '../../styles/LegalPage.css';

interface LegalPageProps {
  file: string;
}

const LegalPage: React.FC<LegalPageProps> = ({ file }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`/legal/${file}`)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load ${file}`);
        return res.text();
      })
      .then((text) => {
        setContent(text);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [file]);

  if (loading) {
    return (
      <div className="legal-page">
        <div className="legal-loading">Loading…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="legal-page">
        <div className="legal-error">Unable to load document. Please try again later.</div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-content">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default LegalPage;
